var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { longFormTemplatesPath, longFormTemplatePath, apiInternalLongFormTemplateLibrariesPath } from '@routes';
import { mapLongFormTemplateFromApi, mapLongFormTemplateLibraryFromApi, mapUpdateTemplateToApiRequest, mapImportTemplateToApiRequest } from './mapper';
/**
 * Fetches all long form templates
 */
export function getLongFormTemplates() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield api.get(longFormTemplatesPath({ format: 'json' }));
            if (!((_a = response.data) === null || _a === void 0 ? void 0 : _a.longFormTemplates)) {
                throw new Error('No data received from server');
            }
            const templates = response.data.longFormTemplates.map(mapLongFormTemplateFromApi);
            return { data: templates };
        }
        catch (error) {
            console.error('Error fetching templates:', error);
            return {
                error: {
                    message: 'Failed to fetch templates. Please try again.'
                }
            };
        }
    });
}
/**
 * Updates an existing long form template
 */
export function updateLongFormTemplate(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = mapUpdateTemplateToApiRequest(data);
            const response = yield api.patch(longFormTemplatePath(id), requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return { data: mapLongFormTemplateFromApi(response.data) };
        }
        catch (error) {
            console.error('Error updating template:', error);
            return {
                error: {
                    message: 'Failed to update template. Please try again.'
                }
            };
        }
    });
}
/**
 * Fetches all long form template libraries and system types
 */
export function getLongFormTemplateLibraries() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield api.get(apiInternalLongFormTemplateLibrariesPath({ format: 'json' }));
            if (!((_a = response.data) === null || _a === void 0 ? void 0 : _a.templates)) {
                throw new Error('No data received from server');
            }
            const libraries = response.data.templates.map(mapLongFormTemplateLibraryFromApi);
            const systemTypes = response.data.systemTypes || [];
            return { data: { libraries, systemTypes } };
        }
        catch (error) {
            console.error('Error fetching libraries:', error);
            return {
                error: {
                    message: 'Failed to fetch libraries. Please try again.'
                }
            };
        }
    });
}
/**
 * Imports a long form template from library
 */
export function importLongFormTemplate(libraryId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = mapImportTemplateToApiRequest(libraryId);
            const response = yield api.post(longFormTemplatesPath({ format: 'json' }), requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return { data: mapLongFormTemplateFromApi(response.data) };
        }
        catch (error) {
            console.error('Error importing template:', error);
            return {
                error: {
                    message: 'Failed to import template. Please try again.'
                }
            };
        }
    });
}
